import React from 'react';
import { connect } from 'react-redux';
import TestDialog from './TestDialog';

function Dialogs(props) {
  const { settings, test } = props.dialogs;
  return (
    <>
      {test !== null && <TestDialog data={test} />}
    </>
  )
}

const mapStateToProps = (state) => ({
  dialogs: state.dialogs,
});

export default connect(mapStateToProps)(Dialogs);